module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group esma_form_group"
  }, [(_vm.showLabel) ? _c('label', {
    class: _vm.labelClass,
    style: (_vm.labelStyle),
    attrs: {
      "for": _vm.fieldID
    }
  }, [_vm._v(_vm._s(_vm.fieldLabel) + " "), (_vm.isRequired) ? _c('span', {
    staticClass: "is_required",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("＊")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.fieldClass,
    staticStyle: {
      "padding": "1px 0px 1px 7px"
    }
  }, [_c('input', {
    ref: "local_value",
    staticClass: "form-control",
    style: (_vm.filedStyle),
    attrs: {
      "type": _vm.fieldType,
      "disabled": _vm.isDisabled,
      "min": _vm.minVal,
      "max": _vm.maxVal,
      "id": _vm.fieldID,
      "name": _vm.fieldID,
      "readonly": _vm.isReadOnly,
      "model": _vm.myModel,
      "placeholder": ""
    },
    domProps: {
      "value": _vm.fieldValue
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.filedStyle.indexOf('block') > -1) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-left": "0px",
      "margin-right": "0px"
    }
  }, _vm._l((_vm.buttons), function(b) {
    return _c('button', {
      key: b.label,
      staticClass: "btn btn-primary esma_btn_form btn-xs",
      style: (b.btn_style),
      attrs: {
        "disabled": (b.type != 'callback' && b.type != 'dlink') || (b.type == 'callback' && (_vm.isDisabled || _vm.realValueEmpty == false)) || (b.type == 'dlink' && (_vm.fieldValue == null || _vm.fieldValue == ''))
      },
      on: {
        "click": function (ev) {
          _vm.onClick(b, ev)
        }
      }
    }, [_vm._v(_vm._s(b.label))])
  })) : _vm._l((_vm.buttons), function(b) {
    return _c('button', {
      key: b.label,
      staticClass: "btn btn-primary esma_btn_form btn-xs",
      style: (b.btn_style),
      attrs: {
        "disabled": (b.type != 'dlink' && b.type != 'callback' && _vm.isDisabled) || _vm.fieldValue == null || _vm.fieldValue == ''
      },
      on: {
        "click": function (ev) {
          _vm.onClick(b, ev)
        }
      }
    }, [_vm._v(_vm._s(b.label))])
  }), _vm._v(" "), (_vm.dbuttons.length > 0) ? _c('span', [_c('dropdown', {
    attrs: {
      "text": "",
      "type": "primary btn  btn-xs btn-primary",
      "disabled": _vm.fieldValue == null || _vm.fieldValue == ''
    }
  }, _vm._l((_vm.dbuttons), function(b) {
    return _c('li', {
      key: b.label
    }, [_c('a', {
      on: {
        "click": function (ev) {
          _vm.onClick(b, ev)
        }
      }
    }, [_vm._v(_vm._s(b.label))])])
  }))], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showErrorMessage),
      expression: "showErrorMessage"
    }],
    staticStyle: {
      "background": "red",
      "color": "white",
      "margin": "2px 0px",
      "padding": "2px 5px"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.erroMessage) + "\n      ")])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6de98222","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/input-box.vue
// module id = 1026
// module chunks = 0